// extracted by mini-css-extract-plugin
export default {"wrapper":"AuctionActivityBeanTitle_wrapper__gc4yf"};